var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.31 35.63a10.31 10.31 0 1 1 0-20.63 10.31 10.31 0 0 1 0 20.63zm0-2.07a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.31 19.13c.57 0 1.03.46 1.03 1.03v5.67a1.03 1.03 0 0 1-2.06 0v-5.67c0-.57.46-1.04 1.03-1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.18 29.7c.4-.4.4-1.06 0-1.46l-2.92-2.93a1.03 1.03 0 1 0-1.46 1.46l2.92 2.93c.4.4 1.06.4 1.46 0z"
  }))));
});